export const constants = {
  DOCS_URL: 'https://docs.y.uno/reference/introduction',
  WRONG_PASSWORD: 'Wrong password',
  CONNECTION_ERROR: 'Connection error',
}

export const keyDownConstants = {
  ENTER: 'Enter',
}
